import { type FC, useCallback, useRef } from "react";
import { DialogComponent, Modal } from "widgets";
import { useOverlay } from "widgets/hooks";

import { SELECTABLE_WORKFLOW_TYPE } from "@/modules/workflow/utils/types.ts";
import { WorkflowSelectionWithPreview } from "@/modules/workflow/WorkflowListingPage.tsx";

interface SelectWorkflowControlledDialogProps {
  isOpen: boolean;
  onClose?: () => void;
  onSelect: (workflowId?: number | null) => void;
  title?: string;
  buttonLabel?: string;
  defaultSelectedWorkflowId?: number;
  /** Limit listing to specific type and hide select  */
  restrictSelectableType?: SELECTABLE_WORKFLOW_TYPE;
}

export const SelectWorkflowControlledDialog: FC<SelectWorkflowControlledDialogProps> = (props) => {
  const { overlayProps, state } = useOverlay({
    isOpen: props.isOpen,
  });

  const currentSelectionRef = useRef<number | undefined>(props.defaultSelectedWorkflowId);

  const setCurrentSelectionHandler = useCallback(
    (workflowId: number | undefined) => (currentSelectionRef.current = workflowId),
    [],
  );

  return (
    <Modal state={state} {...overlayProps}>
      <DialogComponent
        title={props.title ?? "Select Workflow"}
        fullscreen
        closeFn={() => props.onClose?.()}
        mainButton={{
          label: props.buttonLabel ?? "Select",
          isDisabled: false,
          onPress: () => {
            props.onSelect(currentSelectionRef.current);
            props.onClose?.();
          },
          isLoading: false,
        }}
        asPanelHeader={true}
        contentStyle={{ padding: 0, height: "100%" }}
        data-testid="select-workflow"
      >
        <WorkflowSelectionWithPreview
          onOpenWorkflow={(id) => {
            props.onSelect(id);
            props.onClose?.();
          }}
          hideActions
          restrictSelectableType={props.restrictSelectableType}
          defaultSelectedWorkflowId={props.defaultSelectedWorkflowId}
          onSelect={setCurrentSelectionHandler}
        />
      </DialogComponent>
    </Modal>
  );
};
